import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { goBackToHistory } from '../utils/history-navigation-utils';

@Component({
  selector: 'nsl-historyresult',
  templateUrl: './nsl-historyresult.component.html',
  styleUrls: ['./nsl-historyresult.component.scss']
})
export class NSLHistoryResultComponent implements OnInit {

  isSavingRecord;
  individualData = JSON.parse(localStorage.getItem('historyData'))

  constructor(private location: Location) { }

  ngOnInit(): void {
  }

  goBack() {
    goBackToHistory(this.location);
  }

}
